export const imageRegex = /\.(gif|jpe?g|tiff?|png|webp|bmp|avif)$/i;
export const videoRegex = /\.(mp4|mkv|wmv|m4v|mov|avi|flv|webm|flac|mka|m4a|aac|ogg)$/i;